export const PrimaryExternalLinkData = [
    { id: 1, type: "web_social", title: "Website" },
    { id: 2, type: "youtube_social", title: "YouTube" },
    { id: 3, type: "instagram_social", title: "Instagram" },
    { id: 4, type: "facebook_social", title: "Facebook" },
    { id: 5, type: "x_social", title: "X" },
    { id: 6, type: "threads_social", title: "Threads" },
    { id: 7, type: "whatsapp_social", title: "Whatsapp" },
    { id: 8, type: "amazon_social", title: "Amazon" },
    { id: 9, type: "tiktok_social", title: "TikTok" },
    { id: 10, type: "linkedin_social", title: "LinkedIn" },
    { id: 11, type: "spotify_social", title: "Spotify" },
    { id: 12, type: "apple_podcast_social", title: "Apple Podcast" },
    { id: 13, type: "pinterest_social", title: "Pinterest" },
    { id: 14, type: "discord_social", title: "Discord" },
    { id: 15, type: "reddit_social", title: "Reddit" },
    { id: 16, type: "twitch_social", title: "Twitch" },
    { id: 17, type: "snapchat_social", title: "Snapchat" },
    { id: 18, type: "github_social", title: "Github" },
    { id: 19, type: "etsy_social", title: "Etsy" },
  ].sort((a, b) => a.title.localeCompare(b.title));

export async function fetchFaviconImage(urlString: string): Promise<string | null> {
  try {
    const url = new URL(urlString);
    const host = url.hostname;
    const faviconUrl = `https://www.google.com/s2/favicons?sz=128&domain=${host}`;

    const response = await fetch(faviconUrl);
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);

    const blob = await response.blob();
    return URL.createObjectURL(blob); // usable in <img src=...>
  } catch (error) {
    console.error("Failed to fetch favicon:", error);
    return null;
  }
}